import { useDispatch } from 'react-redux';
import { useLazyGetWebSocketTokenQuery } from '~/api/websocket-token-api/websocket-token-api';
import type { ErrorType } from '~/data/ErrorRecord';
import Logger from '~/utils/logger/logger';
import { refreshUser as refreshUserAction } from '~/ducks/authentication/actions';
import useAuthenticationState from '~/ducks/authentication/use-authentication-state';

const useWebToken = () => {
  const dispatch = useDispatch();
  const authentication = useAuthenticationState();
  const [getToken] = useLazyGetWebSocketTokenQuery();
  const fetchToken = async () => {
    if (authentication.provider !== 'isam' && authentication.isUserInfoFetched) {
      try {
        const result = await getToken().unwrap();
        return result.token;
      } catch (e) {
        Logger.error('Failed /websocket/token', e);
        if ((e as ErrorType).status === 401 && authentication.refreshToken) {
          dispatch(refreshUserAction({ token: authentication.refreshToken }));
        }
      }
    }
  };
  return fetchToken;
};
export { useWebToken };
